/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GeneralSearchRequest} from '../models/GeneralSearchRequest';
import type {GeneralSearchResponse} from '../models/GeneralSearchResponse';

export interface RunGeneralSearch$Request {
    generalSearchRequest: GeneralSearchRequest;
}

export interface RunGeneralSearch$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const runGeneralSearchRequest = createAction<PayloadData<void, RunGeneralSearch$Request>>('RUN_GENERAL_SEARCH__RUN_GENERAL_SEARCH__REQUEST');
export const runGeneralSearchSuccess = createAction<PayloadData<GeneralSearchResponse, RunGeneralSearch$Request>>('RUN_GENERAL_SEARCH__RUN_GENERAL_SEARCH__SUCCESS');
export const runGeneralSearchFailure = createAction<PayloadData<Error, RunGeneralSearch$Request, true>>('RUN_GENERAL_SEARCH__RUN_GENERAL_SEARCH__FAILURE');

export const runGeneralSearchActions = [
    runGeneralSearchRequest,
    runGeneralSearchSuccess,
    runGeneralSearchFailure
] as const;

/**
 * @param {GeneralSearchRequest} meta.generalSearchRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const runGeneralSearch = (meta: RunGeneralSearch$Request, config?: RunGeneralSearch$Config) => {
    return {
        CALL_API: {
            types: runGeneralSearchActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/general-search`,
            TRANSPORT_REQUEST_BODY: meta.generalSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

